namespace Core {
    function MonthPicker(
        $location: ng.ILocationService,
        dateUtil: any,
        searchUnitService: SearchUnitService
    ) {
        return {
            scope: {
                value: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=MonthPicker',
            link($scope, $element) {
                $scope.showSelectors = false;

                $scope.range = (() => {
                    const origin = dateUtil.todayPlus(4);
                    const year = origin.getFullYear();
                    const month = origin.getMonth();
                    const months = _.range(month, month + 12);
                    return _.map(months, m => new Date(year, m, 15, 0, 0, 0, 0));
                })();

                $scope.onSelectorClick = ($event:ng.IAngularEvent, date:Date) => {
                    $scope.value = date;
                    $location.search('startDate', dateUtil.format(date, 'yyyy-MM-dd'));
                    searchUnitService.startDate(1, date);
                    $scope.showSelectors = false;
                    if ($event.stopPropagation) { $event.stopPropagation(); }
                };

                $scope.onInputClick = ($event:ng.IAngularEvent) => {
                    $scope.showSelectors = !$scope.showSelectors;
                    if ($event.stopPropagation) { $event.stopPropagation(); }
                };

                $scope.preventClose = ($event:ng.IAngularEvent) => {
                    if ($event.stopPropagation) { $event.stopPropagation(); }
                };

                $(document.body).on('click.monthPicker', e => {
                    $scope.showSelectors = false;
                    $scope.$apply();
                });

                $scope.$on('$destroy', () => {
                    $(document.body).off('click.monthPicker');
                });
            }
        };
    }

    angular
        .module('core')
        .directive('monthPicker', MonthPicker);
}
